<template>
  <div class="sonar-loader__wrapper">
    <ActionLoader v-bind="{ name, color, size }" />
    <div class="sonar-loader__label">{{ label }}</div>
  </div>
</template>

<script>
import ActionLoader from '@/components/shared/ActionLoader.vue'

export default {
  name: 'SonarLoader',
  props: {
    name: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      required: false,
    },
    size: {
      type: Number,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
  },
  components: {
    ActionLoader,
  },
}
</script>

<style lang="scss" scoped>
.sonar-loader {
  &__wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  &__label {
    color: var(--white);
    font-size: rem(18);
    line-height: rem(24);
    margin-top: 20px;
  }
}
</style>
